export const CONFIG = {
    client_name : "stw_osnabrueck",
    client_display_name : "Stadtwerke Osnabrück",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : `https://esr.fe-bis.de/de/stw_osnabrueck/`,
    plz_validation : (plz : string) => plz.length == 5,
    plz_default: "49074",
    foerderung : true,
    development_mode: false,
}
